import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { UnitEditModel } from '../../shared/models/unit-related/UnitEditModel';
import { NonAllocatedSimResultModel } from '../../shared/models/sim-related/NonAllocatedSimResultModel';
import { UnitSimModel } from '../../shared/models/UnitSimModel';

@Injectable()
export class UnitCreateService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/Active/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public GetNonAllocatedSim = (simNo: string, mobileNo: string, ipAddress: string): Observable<NonAllocatedSimResultModel> => {
        this.actionUrl = `${this._configuration.Server}api/NonAllocatedSim/`;
        this.setHeaders();
        let params: URLSearchParams = new URLSearchParams();
        params.set('simNo', simNo);
        params.set('mobileNo', mobileNo);
        params.set('ipAddress', ipAddress);

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public Create = (newUnit: any): Observable<UnitSimModel> => {
        this.actionUrl = `${this._configuration.Server}api/Active/`;
        this.setHeaders();
        newUnit.UserId = this.uData.sub;
        return this._http
            .post(this.actionUrl, JSON.stringify(newUnit), { headers: this.headers }).map(res => res.json());
    }

    public CreateFromOrder = (orderId: string, newUnit: any): Observable<UnitSimModel> => {
        this.actionUrl = `${this._configuration.Server}api/OrderPending/`;
        this.setHeaders();
        newUnit.UserId = this.uData.sub;
        return this._http
            .post(this.actionUrl + orderId, JSON.stringify(newUnit), { headers: this.headers }).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/units/units-create/unit-create.service.ts